module.exports = __webpack_public_path__ + "static/img/case7.d62acbd7.jpg";